<script>
    export let publication;

    import Fa from 'svelte-fa'
    import { faFlag } from '@fortawesome/free-solid-svg-icons'

</script>

<p class="left-align">
    <b class="text-orange">{publication.title}</b><br />
    {@html publication.author}<br />
    {publication.journal}{#if publication.volume}, {publication.volume}{/if}{#if publication.pages}, {publication.pages}{/if} ({publication.year})
    {#if publication.doi}, <a target="_blank" href="https://doi.org/{publication.doi}">{publication.doi}</a>{/if}
</p>

<style>
    .text-orange{
        color: #004f9e;
    }
</style>